/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable @nx/enforce-module-boundaries */
import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import {
  AppstateService,
  AppstateFacade,
} from '@cigna/cigna-for-brokers/shell/data-access';
import { LoginFacade } from '@cigna/cigna-for-brokers/login-data-access';
import { takeUntil, Subject } from 'rxjs';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { ContactUsComponent } from '@cigna/cigna-for-brokers/shared/ui';
import { MatDialog } from '@angular/material/dialog';
import { Menu } from '@cigna/cigna-for-brokers/shared/util';
import includes from 'lodash/includes';
import { MatMenuTrigger } from '@angular/material/menu';
import { Roles } from '../+state/menu-nav.models';
import { Router } from '@angular/router';

@Component({
  selector: 'cigna-caheader-impersonator',
  templateUrl: './header-impersonator.component.html',
  styleUrls: ['./header-impersonator.component.scss'],
})
export class HeaderImpersonatorComponent implements OnInit, OnDestroy {
  @Input() isImpersonationUser: boolean;
  @Input() isImpersonatorSignin: boolean;
  @Input() canEnableImpersonatorLogout: boolean;
  @Input() impFirstName: string | undefined;
  @Input() impLastName: string | undefined;
  @Input() operatorId: string | undefined;
  @Input() menuItemsWithSubMenu?: Menu[];
  @Input() navigationEntitlements: string[] | undefined;
  @Input() firstName: string;
  @Input() lastName: string;
  @Input() internalFirstName: string;
  @Input() internalLastName: string;
  @Input() source: string | undefined;
  @Input() currentUrlPath: string;
  @Input() isSideBarToggleFlag: boolean;
  @Input() isScreenSmall: boolean;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() resizeSideNavToggle: boolean;
  @Input() isImpersonatorFlag: boolean;
  @Input() isCloseIconClicked: boolean;
  @Input() isOktaLoginEnabled: boolean;
  @Input() isUsEmployerOnly: boolean;

  @ViewChild(MatMenuTrigger) matMenuTrigger: MatMenuTrigger;

  isFromBRPortal = true;
  roles$ = this.appStateFacade.roles$;
  hasUSE = false;
  hasSGP = false;
  hasMA = false;
  hasCSB = false;
  hasIFP = false;
  isUseOnly = false;
  isMaCsbOnly = false;
  roles: Roles[] = [];
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();

  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);

  constructor(
    private appStateFacade: AppstateFacade,
    private featureTogglesFacade: FeatureTogglesFacade,
    public _loginFacade: LoginFacade,
    public dialog: MatDialog,
    private appstateService: AppstateService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.roles$.pipe(takeUntil(this._ngUnsubscribe$)).subscribe((resroles) => {
      if (resroles) {
        resroles.forEach((roleitem) => this.processRoleItem(roleitem));
      }
    });

    this.updateUseOnlyFlags();

    this.isOktaLoginEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isOktaLoginEnabled: boolean) => {
        this.isOktaLoginEnabled = isOktaLoginEnabled;
      });

    this.updateIsUsEmployerOnly();
  }

  private processRoleItem(roleitem: Roles): void {
    switch (roleitem.lob) {
      case 'IFP':
        this.hasIFP = true;
        if (
          !this.roles.some(
            (role) => role.producerCode === roleitem.producerCode,
          )
        ) {
          this.roles.push(roleitem);
        }
        break;
      case 'CSB':
        this.hasCSB = true;
        break;
      case 'MA':
        this.hasMA = true;
        break;
      case 'SGP':
        this.hasSGP = true;
        break;
      case 'COMMERCIAL':
        this.hasUSE = true;
        break;
    }
  }

  private updateUseOnlyFlags(): void {
    if (
      this.hasUSE &&
      !this.hasSGP &&
      !this.hasMA &&
      !this.hasCSB &&
      !this.hasIFP
    ) {
      this.isUseOnly = true;
    }

    if (
      this.hasUSE &&
      !this.hasSGP &&
      !this.hasIFP &&
      (this.hasMA || this.hasCSB)
    ) {
      this.isUseOnly = true;
    }
  }

  private updateIsUsEmployerOnly(): void {
    if (!this.menuItemsWithSubMenu) {
      this.isUsEmployerOnly = false;
      return;
    }

    this.isUsEmployerOnly = this.menuItemsWithSubMenu
      .filter((menuItem) => menuItem.entitlement !== 'menu-dashboard')
      .every((menuItem) => menuItem.entitlement === 'menu-commercial-plans');
  }

  processLogout(isImpersonatorSignin: boolean) {
    localStorage.setItem('isfromImpersonator', 'true');

    if (this.isOktaLoginEnabled) {
      this._loginFacade.impersonatorLogout();
    } else {
      this.appStateFacade.impersonatorLogOut(isImpersonatorSignin);
    }
  }

  showContactModal() {
    this.dialog.open(ContactUsComponent, {
      width: '40rem',
      autoFocus: false,
      disableClose: true,
    });
  }

  ngOnDestroy() {
    this._ngUnsubscribe$.next();
    this._ngUnsubscribe$.complete();
  }

  closeIcon() {
    this.isCloseIconClicked = true;
  }

  isContactUsIntuitive(currentUrlPath: string) {
    return includes(currentUrlPath, '/secure/contact-us');
  }

  appRedirect(data: { redirect: string }) {
    this.appStateFacade.appRedirect(data);
  }

  navigateSecureMessageLayout(data: { url: string; target: string }) {
    this.appStateFacade.windowOpen(data);
  }

  closeMenu() {
    this.matMenuTrigger.closeMenu();
  }

  securityProfile(): void {
    if (this.isUseOnly) {
      this.router.navigateByUrl('/secure/new-security-profile');
    }
  }
}
